import type { PropsWithChildren } from "react";
import { BuilderUI } from "@circle-react-shared/BuilderUI";

interface BuilderSidebarProps {
  className?: string;
}

export const BuilderSidebar = ({
  children,
  className,
}: PropsWithChildren<BuilderSidebarProps>) => (
  <BuilderUI.FixedLeftSidebar className={className}>
    {children}
  </BuilderUI.FixedLeftSidebar>
);
